import { IDocVerificationJobApplication } from '../../document-verification/job-application';

export default interface IUser {
  id?: number;
  coreUserId: number;
  firstName: string;
  lastName: string;
  profilePhoto: string;
  name: string;
  username: string;
  email: string;
  password?: string;
  roles: enRoles[];
  isSysAdmin: boolean;
  isConsultant: boolean;
  applications?: any[];
  jobApplications: IDocVerificationJobApplication[];
  active: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum enRoles {
  sysAdmin = 'sysAdmin',
  admin = 'admin',
  candidate = 'candidate',
  employee = 'employee',
  consultant = 'consultant',
  integrator = 'integrator',
  billing = 'billing',
  billingLatam = 'billingLatam',
  billingUS = 'billingUS',
  billingIndia = 'billingIndia',
  billingAmeri100 = 'billingAmeri100',
  zohoAdmin = 'zohoAdmin',
  vendor = 'vendor',
  manager = 'manager',
  comercial = 'comercial',
  deliveryManager = 'deliveryManager',
  accessChat = 'accessChat',
  externalAPI = 'externalAPI',
  DGAdmin = 'DGAdmin',
  sfManageUsers = 'sfManageUsers',
}

export const tspBillingRoles = [
  enRoles.billingLatam,
  enRoles.billingUS,
  enRoles.billingIndia,
];
export const allBillingRoles = [...tspBillingRoles, enRoles.billingAmeri100];
export const adminRoles = [enRoles.sysAdmin, enRoles.admin, enRoles.zohoAdmin];